import { Pipe, PipeTransform } from '@angular/core';

/** Transforms lines of code to a string to copy and paste */
@Pipe({
  name: 'rdsLocClipboard',
})
export class RdsLocClipboardPipe implements PipeTransform {
  transform(loc: string[]): string {
    if (!loc || !loc.length) {
      return '';
    }
    // Join with a newline
    return loc.join('\r\n');
  }
}
